export const formatDongDisplayName = (dongNumber: number, dongName?: string | null): string => {
  const normalizedNumber = `${dongNumber}동`;
  if (!dongName) {
    return normalizedNumber;
  }

  const trimmed = dongName.trim();
  if (trimmed.length === 0) {
    return normalizedNumber;
  }

  const withoutSuffix = trimmed.endsWith('동') ? trimmed.slice(0, -1) : trimmed;
  const numericCandidate = withoutSuffix.replace(/\s+/g, '');
  const isNumericAlias = /^\d+$/.test(numericCandidate);

  if (trimmed === normalizedNumber) {
    return normalizedNumber;
  }

  if (isNumericAlias) {
    const parsed = Number.parseInt(numericCandidate, 10);
    if (!Number.isNaN(parsed) && parsed === dongNumber) {
      return normalizedNumber;
    }
  } else if (/[^\d\s]/.test(withoutSuffix)) {
    return trimmed;
  }

  return `${trimmed} (${normalizedNumber})`;
};
